import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Levantamento',
        [ORDER_METHODS.DELIVERY]: 'Entrega',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Serviço de quarto',
          [RoomServiceLocationType.TableService]: 'Serviço de mesa',
        },
      },
    },
    delivery_info: {
      title: 'Detalhes de entrega',
      on_arrival: 'Na chegada:',
    },
    customer_info: {
      title: 'Contacto',
    },
    payment: {
      title: 'Pagamento',
    },
    request_invoice: {
      title: 'Solicitar fatura',
      form: {
        is_receipt_required: {
          label: 'Solicitar fatura por email',
        },
      },
    },
    location: {
      title: 'Morada da loja',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Morada de entrega',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Morada no local',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Morada de levantamento',
      },
    },
    method: {
      title: 'Método',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Entrega',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'No local',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Levantamento',
      },
    },
    time: {
      title: 'Hora',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Padrão {{time}} min, Hoje',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Agendar para mais tarde',
        },
      },
    },
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Número de quarto',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Número de mesa',
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Tocar à campainha',
        [DropoffAction.Sms]: 'Contactar por SMS à chegada',
      },
    },
    doorbell_name: {
      placeholder: 'Nome da campainha (opcional)',
    },
    company_name: {
      placeholder: 'Nome da empresa (opcional)',
    },
    customer_note: {
      placeholder: 'Alguma nota para o restaurante?',
    },
  },
  buttons: {
    change: 'Alterar',
    edit: 'Editar',
    done: 'Concluído',
    add_delivery_note: '+ Adicionar detalhes de entrega',
    add_order_note: '+ Adicionar nota ao pedido',
  },
  summary: {
    doorbell: 'Campainha',
    company: 'Empresa',
    note: 'Nota do pedido',
  },
};
